import abatuConfig from "./abatu/config";
import charlotteConfig from "./charlotte/config";
import dcConfig from "./dc/config";
import hoteluxConfig from "./hotelux/config";
import hoteluxJPConfig from "./hotelux/configJP";
import itisConfig from "./itis/config";
import luxyglobalConfig from "./luxyglobal/config";
import worldmcConfig from "./worldmc/config";
import samepageConfig from "./samepage/config";
// 其他渠道...

const channelConfigs = {
  Abatu: abatuConfig,
  itis: itisConfig,
  charlotte: charlotteConfig,
  hotelux: hoteluxConfig,
  hoteluxjp: hoteluxJPConfig,
  luxyglobal: luxyglobalConfig,
  dc: dcConfig,
  samepage: samepageConfig,
  worldmc: worldmcConfig
  // 其他渠道...
};

export default function getChannelConfig(channelId: string) {
  return channelConfigs[channelId] || null;
}
